import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { ExecutionsPage } from '@/components/MarketingRules/ExecutionsPage'
import {
  executionsSearchSchema,
  withoutExecutionsSearchDefaults,
} from '@/components/MarketingRules/search'

/** Wiring only. The schema lives beside the page in `search.ts`. */
export const Route = createFileRoute('/_app/marketing/rules-v2/executions/')({
  validateSearch: executionsSearchSchema,
  component: ExecutionsRoute,
})

function ExecutionsRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })

  return (
    <ExecutionsPage
      search={search}
      onSearchChange={(next) =>
        void navigate({
          search: (current) => withoutExecutionsSearchDefaults({ ...current, ...next }),
          replace: true,
        })
      }
    />
  )
}
